module.exports = __webpack_public_path__ + "static/img/3.d4449bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/sky101/3.png
// module id = pzAO
// module chunks = 1